import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ResidentSearchModel } from '@shared/models/data/resident-search-model';
import { ResidentModel } from '@shared/models/data/resident-model';
import { NewResidentDialogComponent } from '../new-resident-dialog/new-resident-dialog.component';
import { AuthService } from '@shared/services/auth.service';
import { ResidentSearchResultDialogComponent } from '../resident-search-result-dialog/resident-search-result-dialog.component';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { ResidentSearchModelResponse } from '@shared/models/data/resident-search-model-response';

@Component({
  selector: 'aaos-app-resident-search-dialog',
  templateUrl: './resident-search-dialog.component.html',
  styleUrls: ['./resident-search-dialog.component.scss']
})
export class ResidentSearchDialogComponent implements OnInit {

  formGroup: FormGroup;
  firstNameControl = 'firstName';
  lastNameControl = 'lastName';
  primaryEmailControl = 'primaryEmail';
  additionalEmailControl = 'additionalEmail';
  npiControl = 'npi';
  dateOfBirthControl = 'dateOfBirth';
  businessPhoneControl = 'businessPhone';
  homePhoneControl = 'homePhone';
  cityControl = 'city';
  stateProvControl = 'stateProv';
  editPrivileges = false;
  loading = false;

  residents: Array<ResidentSearchModel>;
  selectedResident: ResidentSearchModel;
  residentSearchModelResponse: ResidentSearchModelResponse;

  constructor(public searchDialogRef: MatDialogRef<ResidentSearchDialogComponent>,
    private dialog: MatDialog,
    private authService: AuthService,
    private enrollmentService: EnrollmentService
    ) {
      this.enrollmentService.rosterChange.subscribe(() => {
        this.dialog.closeAll();
      });
    }

  ngOnInit() {
    this.createFormGroup();
    this.editPrivileges = this.authService.changeAuthorized();
  }

  invalidRequiredField(fieldName: string): boolean {
    if (this.formGroup.get(fieldName).hasError('required')) {
      return true;
    }
    return false;
  }

  createFormGroup() {
    this.formGroup = new FormGroup({
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      primaryEmail: new FormControl(''),
      additionalEmail: new FormControl(''),
      npi: new FormControl(''),
      dateOfBirth: new FormControl(''),
      businessPhone: new FormControl(''),
      homePhone: new FormControl(''),
      city: new FormControl(''),
      stateProv: new FormControl(''),
    });
  }

  closeDialog() {
    this.searchDialogRef.close();
  }

  onSubmit() {
    this.loading = true;
    let dob: Date = new Date();
    let dobString = '';

    if (this.formGroup.controls[this.dateOfBirthControl].value && this.formGroup.controls[this.dateOfBirthControl].value !== '') {
      dob = new Date(this.formGroup.controls[this.dateOfBirthControl].value);
      dobString = dob.toDateString();
    }

    this.enrollmentService.searchResident(
        this.formGroup.controls[this.lastNameControl].value,
        this.formGroup.controls[this.firstNameControl].value,
        this.formGroup.controls[this.primaryEmailControl].value,
        this.formGroup.controls[this.additionalEmailControl].value,
        this.formGroup.controls[this.npiControl].value,
        dobString,
        this.formGroup.controls[this.businessPhoneControl].value,
        this.formGroup.controls[this.homePhoneControl].value,
        this.formGroup.controls[this.cityControl].value,
        this.formGroup.controls[this.stateProvControl].value,
        40)
        .subscribe(results => {
      this.residents = results.residentList;
      this.residentSearchModelResponse = results;
      this.openResultsDialog();
    });
  }

  openResultsDialog() {
    // open the dialog and then indicate that we're done loading
    const resultsDialogRef = this.dialog.open(ResidentSearchResultDialogComponent, this.getModalConfig());
    this.loading = false;

    resultsDialogRef.componentInstance.actionTaken.subscribe( selection => {
      this.selectedResident = selection;
      if (this.selectedResident != null) {
         this.dialog.open(NewResidentDialogComponent, this.getResidentModalConfig());
      }
    });

  }

  getResidentModalConfig() {
    return {
      panelClass: 'wide-dialog',
      disableClose: true,
      autoFocus: false,
      data: this.selectedResident,
    } as MatDialogConfig;
  }

  getModalConfig() {
    return {
      panelClass: 'wide-dialog',
      disableClose: true,
      autoFocus: false,
      data: this.residentSearchModelResponse,
    } as MatDialogConfig;
  }

  public canAddResident(): boolean {
    return (!this.formGroup.valid || !this.editPrivileges);
  }
}
